<template>
  <b-card
    class="border mt-2"
    :border-variant="cardBorderVariant"
  >
    <template v-if="hasItems">
      <b-row>
        <LmDataTable
          class="col-12"
          :slug="datatableSlug"
          :queryString="selectedQueryString"
          @onSelect="onItemSelectedToBeRemoved"
          :hideSearcher="hideTableSearcher"
          :hideFilters="hideTableFilter"
          :hideButtons="hideTableButtons"
        />
      </b-row>
    </template>
    <template v-else>
      <h4 class="text-center h3 mb-4">
        {{emptyItemsMessage}}
      </h4>
      <lm-button-v2 type="primary" v-b-modal="modalId">
        {{addItemButtonLabel}}
      </lm-button-v2>
    </template>
    <b-modal
      :id="modalId"
      size="xl"
      scrollable
      hide-header
      @ok="onAddItems"
      :cancel-title="$t('cancel')"
      :ok-title="$t('confirm')"
    >
      <LmDataTable
        ref="datatable-in-modal"
        :slug="datatableModalSlug"
        :queryString="itemsToExclude"
        hideButtons
      />
    </b-modal>
    <template v-if="hasItems" #footer>
      <div class="d-flex">
        <a-tooltip>
          <template slot="title">
            {{$t('add')}}
          </template>
          <a-button
            v-b-modal="modalId"
            class="co-auto"
            type="primary"
            shape="circle"
            size="large"
            ghost
          >
            <font-awesome-icon icon="plus" />
          </a-button>
        </a-tooltip>
        <a-tooltip>
          <template slot="title">
            {{$t('delete')}}
          </template>
          <a-button
            v-if="itemsSelecetedToBeRemoved.length"
            @click="onRemoveItemsConfirmation"
            class="cl-auto ml-2"
            type="danger"
            shape="circle"
            size="large"
            ghost
          >
            <font-awesome-icon icon="trash" />
          </a-button>
        </a-tooltip>
      </div>
    </template>
  </b-card>
</template>

<script>
import { defineComponent } from 'vue'
import LmButtonV2 from '@/components/form/elements/LmButtonV2'
import LmDataTable from '@/components/lmDataTable/table'
import lmToasts from '@/mixins/lmToasts.js'

export default defineComponent({
  mixins: [lmToasts],
  components: {
    LmButtonV2,
    LmDataTable
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    addItemButtonLabel: {
      type: String,
      required: true
    },
    datatableSlug: {
      type: String,
      required: true
    },
    datatableModalSlug: {
      type: String,
      required: true
    },
    emptyItemsMessage: {
      type: String,
      required: true
    },
    removeConfirmationMessage: {
      type: String,
      required: true
    },
    hideTableButtons: {
      type: Boolean,
      default: true
    },
    hideTableSearcher: {
      type: Boolean,
      default: false
    },
    hideTableFilter: {
      type: Boolean,
      default: false
    },
    cardBorderVariant: {
      type: String,
      default: null
    }
  },
  data: () => ({
    modalId: '',
    isLoading: false,
    isProcessing: false,
    isTableLoading: false,
    itemsSelecetedToBeRemoved: []
  }),
  computed: {
    hasItems () {
      return this.items?.length > 0
    },
    selectedQueryString () {
      let qs = ''

      if (this.hasItems) {
        const ids = this.items.map(el => el.id)
        if (ids.length) {
          qs = '(id: (' + ids.join(' OR ') + '))'
        }
      }
      return qs
    },
    itemsToExclude () {
      let qs = '*'

      if (this.hasItems) {
        const ids = this.items.map(el => el.id)
        if (ids.length) {
          qs = 'NOT (id: (' + ids.join(' OR ') + '))'
        }
      }
      return qs
    }
  },
  methods: {
    onItemSelectedToBeRemoved (event) {
      this.itemsSelecetedToBeRemoved = event
    },
    onAddItems () {
      const selected = this.$refs['datatable-in-modal'].dataValue
      this.$emit('itemsAdded', selected)
    },
    onRemoveItemsConfirmation () {
      this.lmModalInformationMessage({
        modalClosable: false,
        modalKeyboard: false,
        resultSubtitle: '',
        buttons: [
          {
            btnText: this.$t('cancel'),
            btnType: 'danger',
            btnGhost: true,
            btnCallback: () => {
              this.isProcessing = false
            }
          },
          {
            btnText: this.$t('continue'),
            btnCallback: () => {
              this.onRemoveItems()
            }
          }
        ],
        message: this.removeConfirmationMessage
      })
    },
    async onRemoveItems () {
      try {
        if (this.itemsSelecetedToBeRemoved.length === 0) {
          return
        }
        this.$emit('itemsToRemove', this.itemsSelecetedToBeRemoved)
        this.itemsSelecetedToBeRemoved = []
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    }
  },
  async created () {
  },
  mounted () {
    // Genera un ID aleatorio cuando el componente se monta
    this.modalId = 'datatable-modal-' + Math.random().toString(36).substring(2, 9)
  }
})
</script>

<style scoped>
</style>
